
import { useState, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { 
  getReportsForModeration, 
  updateReportStatus, 
  checkIfUserIsModerator,
  Report 
} from '../services/moderationService';

export const useModeration = () => {
  const [isModerator, setIsModerator] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    const checkModerator = async () => {
      const result = await checkIfUserIsModerator();
      setIsModerator(result);
    };
    checkModerator();
  }, []);

  const { data: reports, isLoading, error } = useQuery({
    queryKey: ['reports'],
    queryFn: getReportsForModeration,
    enabled: isModerator,
  });

  const updateReportMutation = useMutation({
    mutationFn: ({ reportId, status, notes }: { 
      reportId: string; 
      status: string; 
      notes?: string 
    }) => updateReportStatus(reportId, status, notes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reports'] });
    },
  });

  return {
    reports: reports || [],
    isLoading,
    error,
    isModerator,
    updateReport: updateReportMutation.mutate,
    isUpdating: updateReportMutation.isPending,
  };
};
